import { createThis2j2avj17cvnv2 as createThis } from '../js/coreRuntime.mjs';
import {
  CoroutineSingletons_UNDECIDED_getInstancezhfvt404mg6o as CoroutineSingletons_UNDECIDED_getInstance,
  CoroutineSingletons_RESUMED_getInstance10y7d0morijg6 as CoroutineSingletons_RESUMED_getInstance,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
} from './intrinsics/Intrinsics.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import {
  _Result___get_value__impl__bjfvqg3630bgmytqwyb as _Result___get_value__impl__bjfvqg,
  Failure21qmuqji4xbjp as Failure,
} from '../Result.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from './Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SafeContinuationClass;
function SafeContinuation() {
  if (SafeContinuationClass === VOID) {
    class $ {
      static md(delegate, initialResult) {
        var $this = createThis(this);
        $this.kd_1 = delegate;
        $this.ld_1 = initialResult;
        return $this;
      }
      static nd(delegate) {
        return this.md(delegate, CoroutineSingletons_UNDECIDED_getInstance());
      }
      rc() {
        return this.kd_1.rc();
      }
      tc(result) {
        var cur = this.ld_1;
        if (cur === CoroutineSingletons_UNDECIDED_getInstance()) {
          this.ld_1 = _Result___get_value__impl__bjfvqg(result);
        } else if (cur === get_COROUTINE_SUSPENDED()) {
          this.ld_1 = CoroutineSingletons_RESUMED_getInstance();
          this.kd_1.tc(result);
        } else
          throw IllegalStateException().o('Already resumed');
      }
      od() {
        if (this.ld_1 === CoroutineSingletons_UNDECIDED_getInstance()) {
          this.ld_1 = get_COROUTINE_SUSPENDED();
          return get_COROUTINE_SUSPENDED();
        }
        var result = this.ld_1;
        var tmp;
        if (result === CoroutineSingletons_RESUMED_getInstance()) {
          tmp = get_COROUTINE_SUSPENDED();
        } else {
          if (result instanceof Failure()) {
            throw result.pd_1;
          } else {
            tmp = result;
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'SafeContinuation', VOID, VOID, [Continuation()]);
    SafeContinuationClass = $;
  }
  return SafeContinuationClass;
}
//region block: exports
export {
  SafeContinuation as SafeContinuation1x0fxyaxo6cwq,
};
//endregion

//# sourceMappingURL=SafeContinuationJs.mjs.map
